import { useEffect, useState } from 'react'
import { getQuizResult } from '../api'

const useGetSession = (id: string | null): any => {
  const [session, setSession] = useState<any>(id === null ? null : undefined)
  useEffect(() => {
    if (id === null) return
    getQuizResult(id)
      .then((data) => {
        setSession({ results: JSON.parse(data.result_data), timer: data.timer, permalink: data.permalink })
      })
      .catch((error: unknown) => {
        console.error(error)
      })
  }, [id])
  return { session }
}

export default useGetSession
